export const SUBMIT_SEARCH_REINDEX = {
  REQUEST: "SUBMIT_SEARCH_REINDEX_REQUEST",
  SUCCESS: "SUBMIT_SEARCH_REINDEX_SUCCESS",
  FAILURE: "SUBMIT_SEARCH_REINDEX_FAILURE",
};

export const SEARCH_REINDEX_STARTED = "SEARCH_REINDEX_STARTED";
export const SEARCH_REINDEX_COMPLETED = "SEARCH_REINDEX_COMPLETED";

export const FETCH_SEARCH_REINDEX_REQUESTS = {
  REQUEST: "FETCH_SEARCH_REINDEX_REQUESTS_REQUEST",
  SUCCESS: "FETCH_SEARCH_REINDEX_REQUESTS_SUCCESS",
  FAILURE: "FETCH_SEARCH_REINDEX_REQUESTS_FAILURE",
};

export type SearchReindexOutcome = "done" | "failed" | "unknown";

export interface RunningSearchReindex {
  requestId: string;
  storeId: string;
  startedAt: string;
}

export interface SearchReindexResult {
  requestId: string;
  storeId: string;
  statusCode: number;
  status: SearchReindexOutcome;
  executionId?: string;
  reason?: string;
  errorMessage?: string;
}

export interface SearchReindexState {
  submitting: boolean;
  running: RunningSearchReindex | null;
  lastResult: SearchReindexResult | null;
}

export interface SubmitSearchReindexAction {
  type: typeof SUBMIT_SEARCH_REINDEX.REQUEST;
}

export interface SubmitSearchReindexSuccessAction {
  type: typeof SUBMIT_SEARCH_REINDEX.SUCCESS;
  payload: { requestId: string; storeId: string };
}

export interface SearchReindexStartedAction {
  type: typeof SEARCH_REINDEX_STARTED;
  payload: RunningSearchReindex;
}

export interface SearchReindexCompletedAction {
  type: typeof SEARCH_REINDEX_COMPLETED;
  payload: SearchReindexResult;
}

export interface FetchSearchReindexRequestsAction {
  type: typeof FETCH_SEARCH_REINDEX_REQUESTS.REQUEST;
}

export interface SearchReindexRequestRecord {
  requestId: string;
  status: "IN_PROGRESS" | "SUCCEEDED" | "FAILED";
  createdAt: string;
  request?: { headers?: { "x-store-id"?: string } };
  response?: {
    statusCode: number;
    body?: {
      status?: SearchReindexOutcome;
      executionId?: string;
      reason?: string;
      message?: string;
    };
  };
}

export interface SubmitSearchReindexFailureAction {
  type: typeof SUBMIT_SEARCH_REINDEX.FAILURE;
}

export type SearchReindexActionTypes =
  | SubmitSearchReindexAction
  | SubmitSearchReindexSuccessAction
  | SubmitSearchReindexFailureAction
  | SearchReindexStartedAction
  | SearchReindexCompletedAction;
